module.exports = __webpack_public_path__ + "static/img/google-logo.c6c8eeb2.svg";